import { ReactElement, useEffect } from 'react';
import { connect } from 'react-redux';
import {
	AppState,
	AppThunkDispatch,
	createNewLicence,
	fetchAllLicences,
	fetchLicence,
	Licence,
	LicenceActions,
	loadDefaultLicence,
	updateExistingLicence
} from '../../../../../redux';
import { BackButton, PageContainer } from '../../../../molecules';
import { LicenceManagerForm } from '../../../../organisms';

export interface ILicenceManagerPageProps {
	licence: Licence;
	licences: Licence[];
	fetchLicence: (id: string) => void;
	fetchAllLicences: () => void;
	fetchDefaultLicence: () => void;
	createLicence: (licence: Licence) => void;
	updateLicence: (licence: Licence) => void;
}

export interface ILicenceManagerRouteParams {
	id?: string;
}

function LicenceManagerPageView(
	props: ILicenceManagerPageProps & ILicenceManagerRouteParams
): ReactElement {
	const {
		id,
		licence,
		licences,
		fetchLicence,
		fetchAllLicences,
		fetchDefaultLicence,
		createLicence,
		updateLicence
	} = props;

	useEffect(() => {
		if (id && id !== licence.id) {
			fetchLicence(id);
		} else if (!id) {
			fetchDefaultLicence();
		}
		fetchAllLicences();
	}, []);

	function hasLoaded(): boolean {
		if (id === licence.id || !id) return true;
		return false;
	}

	function handleSave(licence: Licence): void {
		if (licence.id) {
			updateLicence(licence);
		} else {
			createLicence(licence);
		}
	}

	return (
		<PageContainer
			smallPadding
			id="licence-manager-page"
			hasLoaded={hasLoaded()}
		>
			<BackButton />
			<LicenceManagerForm
				licence={licence}
				licences={licences}
				onSave={handleSave}
			/>
		</PageContainer>
	);
}

function mapStateToProps(
	state: AppState,
	ownProps: ILicenceManagerRouteParams
) {
	return {
		id: ownProps.id,
		licence: state.licences.licence,
		licences: state.licences.licences
	};
}

function mapDispatchToProps(dispatch: AppThunkDispatch<LicenceActions>) {
	return {
		fetchLicence: (id: string) => dispatch(fetchLicence(id)),
		fetchAllLicences: () => dispatch(fetchAllLicences()),
		fetchDefaultLicence: () => dispatch(loadDefaultLicence()),
		createLicence: (licence: Licence) =>
			dispatch(createNewLicence(licence)),
		updateLicence: (licence: Licence) =>
			dispatch(updateExistingLicence(licence))
	};
}

export const LicenceManagerPage = connect(
	mapStateToProps,
	mapDispatchToProps
)(LicenceManagerPageView);
